import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CardContent from '@material-ui/core/CardContent';
import {
  withStyles, Grid, Typography, IconButton,
} from '@material-ui/core';
import FavouritesBtn from 'components/Favourites/FavouritesBtn';
import { Link } from 'react-router-external';
import utils from 'utils';
import _ from 'lodash';
import classNames from 'classnames';
import BreakpointsConfig from 'configs/BreakpointsConfig';

const styles = theme => ({
  root: {
    '&:hover': {
      '& .image': {
        borderRadius: 0,
      },
    },
    '& a': {
      color: '#000 !important',
    },
  },
  title: {
    'padding-bottom': '1.2rem !important',
  },
  descriptionn: {
    '& ul': {
      'padding-inline-start': '20px',
    },
  },
  circular: {
    borderRadius: '50%',
  },
  iconMessenger: {
    width: 18,
    height: 18,
  },
  borderColor: {
    position: 'relative',
    '&:before': {
      content: '\'\'',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: 2,
      backgroundColor: '#cdcccb',
    },
  },
  btnBorder: {
    borderRadius: 0,
    padding: 2,
    '&:hover': {
      borderRadius: '50%',
    },
    [theme.breakpoints.down(BreakpointsConfig.md)]: {
      borderRadius: 0,
    },
  },
  mt1: {
    [theme.breakpoints.down(BreakpointsConfig.md)]: {
      marginTop: 1,
    },
  },
});

class CardDeal extends Component {
  componentDidMount() {
    window.addthis && window.addthis.toolbox('.addthis_toolbox');
  }

  render() {
    const {
      classes, className, page, addthis, type, hideSocial, content, circular, variant, children, origin,
    } = this.props;
    const title = content.title || content.name;
    const image = content.image || content.img || content.picture;
    const full_description = content.full_description || '';
    const htmlDescription = _.includes(full_description, '<ul>');
    const imageURL = utils.resolveImageUrl(content.image || content.img || content.picture);
    let variantClass;
    const bgInlineStyle = {
      background: `url("${decodeURI(imageURL)}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      transition: 'all .3s ease-in-out',
    };

    switch (variant) {
      case 'contained':
        variantClass = `${classes.contained}`;
        bgInlineStyle.width = '100%';
        break;
      case 'transparent':
        break;
      default:
        break;
    }
    const url = `${window.location.origin}/${type}/${content.slug}`;
    return (
      <div className={`${classes.root} overflow-hidden flex flex-col h-full font-serif justify-center items-stretch  min-h-96 ${classes.borderColor} ${variantClass} ${className}`}>
        <div className="flex-1 w-full" style={{flexBasis: 'auto'}}>
          {image
            && (
              <Link to={`/${type}/${content.slug}`}>
                <div
                  data-track={`${origin} >> ${title}`}
                  className={`${circular && classes.circular} image cursor-pointer w-224 h-224 mx-auto ${variant === 'transparent' ? 'w-full max-h-192' : ''}`}
                  style={bgInlineStyle}
                />
              </Link>
            )
          }
          <div className="self-start">
            <Grid container alignContent="space-between">
              <Grid item xs={hideSocial ? 12 : 9}>
                <CardContent className={`${classes.title} ${hideSocial ? 'mt-4' : 'pr-0 pl-0'}`}>
                  {title && (
                    <Typography
                      component={Link}
                      to={`/${type}/${content.slug}`}
                      variant="inherit"
                      className="text-18 text-black no-underline font-serif text-left cursor-pointer"
                    >
                      <span data-track={`${origin} >> ${title}`}>{title}</span>
                    </Typography>)}
                  {children}
                </CardContent>
              </Grid>
              {!hideSocial
                && (
                  <Grid item xs={3} className="w-full self-start mt-16 md:mt-20">
                    <Grid container alignContent="space-between" justify="flex-end">
                      <Grid item xs={6}>
                        {addthis.isLoaded
                          && (
                            <div className="addthis_toolbox block overflow-hidden" data-addthis-url={url}>
                              <a href="/#" className="addthis_button_compact relative float-right">
                                <IconButton aria-label="Share" className={classes.btnBorder}>
                                  <img className={classNames(classes.iconMessenger)} src='/assets/images/icon-share.png' alt='icon share' />
                                  <div
                                    className="absolute w-full h-full pin-t mr-0"
                                    data-track={`${origin} >> ${content.title} >> share`}
                                  />
                                </IconButton>
                              </a>
                            </div>
                          )
                        }
                      </Grid>
                      <Grid item xs={6} className="pr-0">
                        <FavouritesBtn className={classNames("block overflow-hidden", classes.mt1)} type={type} page={page} item={content} origin={origin}/>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              }

              <Grid item xs={12}>
                <CardContent className={`${hideSocial ? '' : 'pr-0 pl-0'} ${variant === 'transparent' ? 'p-0' : 'pt-0'}`}>
                  {full_description && htmlDescription ? (
                    <Typography className="text-14 font-sans">
                      <span className={classes.descriptionn} dangerouslySetInnerHTML={{ __html: _.truncate(full_description, {length:174})}}></span>
                    </Typography>) : (
                    <Typography className="text-14 font-sans">
                      <span dangerouslySetInnerHTML={{__html: full_description}}/>
                      </Typography>
                  )}
                </CardContent>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ addthis }) {
  return {
    addthis,
  };
}
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(CardDeal)));
